import { Component, Input, OnInit } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { SectorRefundService } from '../services/sector-refund.service';
import { LegRefundModel } from '../models/models/leg-refund-model';
import { CommonServiceService } from 'src/app/shared/common-service.service';


@Component({
  selector: 'app-sector-info-refund',
  templateUrl: './sector-info-refund.component.html',
  styleUrls: ['../flight-refund.component.scss','../../invoice-refund.component.scss']
})
export class SectorInfoRefundComponent implements OnInit {
	dateTimeMultiTab: string = "false";

	@Input() manualEntryChecked
	bsConfig: Partial<BsDatepickerConfig>;
	colorTheme = 'theme-orange';
	leg : LegRefundModel = new LegRefundModel();
	@Input() sectorService;
	@Input() isTenantIndian;
	dateFormat = 'YYYY-MM-DD';
	dateTimeFormat = 'YYYY-MM-DD HH:mm';
	timeFormat = 'HH:mm';
  	isLocaleDateFormat: boolean = true;
	constructor(
		// public sectorService : SectorRefundService
				public commonService : CommonServiceService
		
		) { }

	async ngOnInit() {
		this.bsConfig = Object.assign({ dateInputFormat: 'DD/MM/YYYY HH:mm' }, { containerClass: this.colorTheme }, { showWeekNumbers: false })	
		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
			let inv_config = globalSettingConfig.filter(el=>el.group=='FLIGHT_INV')
			if(inv_config.length){
				let multi_tav_config = inv_config[0].json_doc.value.filter(el=>el.key=='MULTI TAB TRAVEL DATE TIME')
				if(multi_tav_config && multi_tav_config.length>0) this.dateTimeMultiTab = multi_tav_config[0].value
			}
		let transaction_config = globalSettingConfig.filter(el=>el.group=='TRANSACTION')
		if(transaction_config && transaction_config.length>0){      
			let dateConfig = await this.commonService.getDateFormat('date_format')
			this.dateFormat = dateConfig.dateFormat
			let dateTimeConfig = await this.commonService.getDateFormat('date_time_format')
			this.dateTimeFormat = dateTimeConfig.dateFormat
			this.isLocaleDateFormat = dateConfig.isLocaleDateFormat
		}
	}
	getValue(data){
		console.log(data)
	}
}
